import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78c951b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flow-record-list" }
const _hoisted_2 = { class: "flow-record-item collapsed-item" }
const _hoisted_3 = { class: "record-time cm-ui-ml10 cm-ui-mr10" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "record-result" }
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}

import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Card from '@/views/dashboard/_components/card/card.vue'
import FlowRecordPopoverDetail from './flow-record-popover-detail.vue'

type FlowRecordItem = {
  id: string
  type: number
  time: string
  title: string
  user: string
  status: 'approved' | 'rejected'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'flow-record-sidebar',
  props: {
    data: { default: () => [] },
    loading: { type: Boolean, default: false },
    collapsed: { type: Boolean, default: false },
    disabledPopover: { type: Boolean, default: false },
    loadMoreConfig: { default: undefined },
    embed: { type: Boolean, default: false }
  },
  emits: ["update:collapsed"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
// 流转记录项类型（简化版，直接使用后端数据）
const props = __props

const emit = __emit

const flowRecords = ref<FlowRecordItem[]>([])

const flowOuterAttrs = computed(() => {
  if (props.embed) {
    return { class: 'flow-record-sidebar flow-record-sidebar--embed' }
  }
  return {
    size: 'second',
    class: 'flow-record-sidebar',
    title: props.collapsed ? '' : t('approvalCenter.flowRecord')
  }
})

const loadMoreConfig = computed(() => {
  // 收起时禁用滚动加载
  if (props.collapsed) {
    return {
      callback: () => { },
      loading: false,
      hasMore: false,
      disabled: true,
      threshold: 10,
      delay: 100
    }
  }
  return props.loadMoreConfig || {
    callback: () => { },
    loading: false,
    hasMore: false,
    disabled: true,
    threshold: 10,
    delay: 100
  }
})

function handleToggleCollapse() {
  emit('update:collapsed', !props.collapsed)
}

watch(() => props.data, (newData) => {
  flowRecords.value = newData
}, { immediate: true, deep: true })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.embed ? 'div' : Card), _mergeProps(flowOuterAttrs.value, { style: {"height":"100%"} }), _createSlots({
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowRecords.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_popover, {
            key: item.id,
            disabled: _ctx.disabledPopover,
            placement: "left",
            trigger: "hover",
            width: 280,
            "popper-class": "flow-record-popover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.collapsed)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["record-dot", item.status === 'approved' ? 'dot-approved' : 'dot-rejected'])
                    }, null, 2))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["record-dot", item.status === 'approved' ? 'dot-approved' : 'dot-rejected'])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.time), 1),
                      _createElementVNode("span", {
                        class: "record-desc",
                        title: item.title
                      }, _toDisplayString(item.title), 9, _hoisted_4),
                      _createElementVNode("span", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.$t('approvalCenter.approvedBy')) + " " + _toDisplayString(item.user) + " ", 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(item.status === 'approved' ? 'status-approved' : 'status-rejected')
                        }, _toDisplayString(item.status === 'approved' ? _ctx.$t('approvalCenter.approvedLabel') : _ctx.$t('approvalCenter.rejectedLabel')), 3)
                      ])
                    ], 64))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(FlowRecordPopoverDetail, { item: item }, null, 8, ["item"])
            ]),
            _: 2
          }, 1032, ["disabled"]))
        }), 128)),
        (!flowRecords.value.length && !_ctx.loading && !_ctx.collapsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('approvalCenter.flowRecordEmpty')), 1))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading],
        [_directive_load_more, loadMoreConfig.value]
      ])
    ]),
    _: 2
  }, [
    (!_ctx.embed)
      ? {
          name: "headerRight",
          fn: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              onClick: handleToggleCollapse,
              style: {"padding":"0","margin-left":"auto","color":"var(--cm-color-text-regular)"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.collapsed ? _ctx.$t('approvalCenter.expand') : _ctx.$t('approvalCenter.collapse')), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1040))
}
}

})